export class NoInsurancePolicyModel {
    nipId: string;
    nipAssociatedOuId: any;
    nipIagPartnerCaseNumber: string;
    nipCoverageType: string;
    nipPolicyCheckStatus : string;
    nipDossierId: string;
}